/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedStarRating_seller = {
    readonly orderFeedbackPdp: {
        readonly metadata: {
            readonly aggregatedFeedback: {
                readonly overallExperience: {
                    readonly mean: number | null;
                } | null;
            } | null;
        } | null;
    } | null;
    readonly " $refType": "PdpSharedStarRating_seller";
};
export type PdpSharedStarRating_seller$data = PdpSharedStarRating_seller;
export type PdpSharedStarRating_seller$key = {
    readonly " $data"?: PdpSharedStarRating_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedStarRating_seller">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedStarRating_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "orderFeedbackPdp",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerOrderFeedbackPdpQueryConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "metadata",
          "storageKey": null,
          "args": null,
          "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "aggregatedFeedback",
              "storageKey": null,
              "args": null,
              "concreteType": "AggregatedOrderFeedbackType",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "overallExperience",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "AggregatedOrderFeedbackQuestionType",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "mean",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '3b8f870f28b8b0e6af5e0cad1087f6f5';
export default node;
